module.exports = __webpack_public_path__ + "img/vsBronzer1.29e65fd0.jpg";